import axios from "../../axios";

const createProxy = async function (accessToken, data = {}) {
    try {
        const response = await axios.post('proxy/createProxy', data, {
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status || 500,
            message: e.response?.data?.message || 'Có lỗi xảy ra'
        }
    }
}

export default createProxy;

